"use client"

import { useState } from "react"
import "./SharePanel.css"
import { trackShare } from "../../utils/analytics"

export default function SharePanel({ shareText, url, onClose }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareText)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      if (process.env.NODE_ENV === "development") console.error("Failed to copy:", error)
    }
  }

  const shareToSocial = (platform) => {
    let shareUrl = ""

    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
        break
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`
        break
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText + " " + url)}`
        break
      case "telegram":
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(shareText)}`
        break
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
        break
      default:
        return
    }

    // Track share event
    trackShare(platform);

    window.open(shareUrl, "_blank", "width=600,height=400")
  }

  return (
    <div className="share-panel-inline">
      <div className="share-panel-header">
        <h3>Share with Friends</h3>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
      </div>

      <div className="share-link-section">
        <div className="share-link-container">
          <textarea value={shareText} readOnly className="share-link-input" />
          <button className="copy-button" onClick={handleCopy}>
            {copied ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20 6L9 17L4 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
                <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.666 2.888C12.5327 2.4163 12.2489 2.00105 11.858 1.70538C11.467 1.40972 10.9902 1.24982 10.5 1.25H7.5C6.47 1.25 5.6 1.943 5.334 2.888M12.666 2.888C12.721 3.082 12.75 3.288 12.75 3.5C12.75 3.69891 12.671 3.88968 12.5303 4.03033C12.3897 4.17098 12.1989 4.25 12 4.25H6C5.80109 4.25 5.61032 4.17098 5.46967 4.03033C5.32902 3.88968 5.25 3.69891 5.25 3.5C5.25 3.288 5.28 3.082 5.334 2.888M12.666 2.888C13.312 2.937 13.954 2.998 14.593 3.072C15.693 3.2 16.5 4.149 16.5 5.257V18.5C16.5 19.0967 16.2629 19.669 15.841 20.091C15.419 20.5129 14.8467 20.75 14.25 20.75H3.75C3.15326 20.75 2.58097 20.5129 2.15901 20.091C1.73705 19.669 1.5 19.0967 1.5 18.5V5.257C1.5 4.149 2.306 3.2 3.407 3.072C4.04804 2.99778 4.6905 2.93643 5.334 2.888" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            )}
          </button>
        </div>
      </div>

      

      <div className="share-to-section">
        <div className="social-icons">
          <div className="social-icon" onClick={() => shareToSocial("facebook")}>
            <div className="icon-circle facebook">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M44 24.1213C44 13.008 35.0467 4 24 4C12.9533 4 4 13.008 4 24.1213C4 34.1667 11.312 42.4907 20.8747 44V29.9387H15.7973V24.12H20.8747V19.688C20.8747 14.6453 23.86 11.8587 28.4293 11.8587C30.616 11.8587 32.9067 12.252 32.9067 12.252V17.204H30.3827C27.8987 17.204 27.1253 18.756 27.1253 20.348V24.1213H32.672L31.7853 29.9373H27.1253V44C36.688 42.4907 44 34.1667 44 24.1213Z" fill="white"/>
</svg>


            </div>
            <span>Facebook</span>
          </div>
          <div className="social-icon" onClick={() => shareToSocial("twitter")}>
            <div className="icon-circle twitter">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M39.9868 20.0007C39.9868 30.102 32.5014 38.4529 22.7772 39.808C21.8679 39.9341 20.9377 40 19.9934 40C18.9034 40 17.8331 39.9131 16.7908 39.745C7.27109 38.2118 0 29.9548 0 20.0007C0 8.95491 8.95227 0 19.9948 0C31.0373 0 39.9896 8.95491 39.9896 20.0007H39.9868Z" fill="white"/>
<path d="M10.0481 11L17.7698 21.3268L10 29.7232H11.7492L18.5523 22.3724L24.0486 29.7232H30L21.8442 18.8155L29.0767 11H27.3275L21.0629 17.7699L16.0007 11H10.0493H10.0481ZM12.6197 12.2885H15.3531L27.4261 28.4347H24.6926L12.6197 12.2885Z" fill="black"/>
</svg>

            </div>
            <span>X</span>
          </div>
          <div className="social-icon" onClick={() => shareToSocial("whatsapp")}>
            <div className="icon-circle whatsapp">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.0755 0.580566C8.19522 0.580566 0.154452 8.32521 0.150968 17.8431C0.148645 20.8869 0.975484 23.8575 2.54323 26.4739L0 35.4193L9.50284 33.0189C12.1462 34.4016 15.0854 35.1229 18.0685 35.1208H18.0755C27.9557 35.1208 35.9965 27.375 36 17.8571C36.0023 13.2468 34.1396 8.90702 30.7545 5.64495C27.3705 2.38173 22.8705 0.581728 18.0755 0.580566ZM18.0755 32.2048H18.0697C15.3964 32.2048 12.7742 31.5127 10.4865 30.2051L9.94065 29.8939L4.30374 31.3176L5.80877 26.0221L5.45458 25.4798C3.96686 23.2108 3.17489 20.5564 3.17613 17.8431C3.17961 9.93128 9.864 3.49657 18.0813 3.49657C22.0599 3.49773 25.8004 4.99231 28.6142 7.70392C31.428 10.4155 32.976 14.0213 32.9737 17.8559C32.9702 25.7678 26.287 32.2048 18.0743 32.2048H18.0755ZM26.2475 21.4571C25.7992 21.2422 23.5974 20.1982 23.1863 20.0531C22.7764 19.9102 22.4779 19.8359 22.1795 20.2679C21.8822 20.6999 21.0228 21.6719 20.7627 21.9588C20.5003 22.2468 20.239 22.2816 19.7907 22.0668C19.3425 21.8508 17.899 21.3955 16.1895 19.9253C14.8575 18.7826 13.9587 17.3705 13.6974 16.9373C13.4361 16.5065 13.6695 16.2731 13.8937 16.0582C14.0946 15.8666 14.3419 15.5554 14.5649 15.3034C14.7879 15.0514 14.8622 14.8714 15.0132 14.5834C15.1618 14.2966 15.0875 14.0434 14.9748 13.8286C14.8622 13.6114 13.968 11.4886 13.5929 10.6257C13.2306 9.78495 12.8613 9.8976 12.5861 9.88366C12.3248 9.87205 12.0275 9.86857 11.7267 9.86857C11.4306 9.86857 10.944 9.97657 10.5329 10.4086C10.123 10.8406 8.96516 11.8834 8.96516 14.0062C8.96516 16.1302 10.5701 18.1811 10.7942 18.4691C11.0183 18.7559 13.9529 23.1142 18.4459 24.9839C19.5143 25.4264 20.3481 25.6923 20.9996 25.8921C22.0726 26.2207 23.0493 26.1731 23.8204 26.0628C24.6797 25.9385 26.4705 25.0199 26.8421 24.0131C27.216 23.0062 27.216 22.1422 27.1045 21.9622C26.9954 21.7822 26.6957 21.6742 26.2475 21.4571V21.4571Z" fill="white"/>
</svg>


            </div>
            <span>Whatsapp</span>
          </div>
          <div className="social-icon" onClick={() => shareToSocial("telegram")}>
            <div className="icon-circle telegram">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20ZM20.7167 14.7649C18.7714 15.574 14.8835 17.2487 9.05312 19.7889C8.10635 20.1654 7.61039 20.5337 7.56524 20.8939C7.48894 21.5025 8.25115 21.7422 9.28908 22.0686C9.43027 22.113 9.57655 22.159 9.72653 22.2077C10.7477 22.5397 12.1213 22.928 12.8354 22.9434C13.4832 22.9574 14.2062 22.6904 15.0044 22.1423C20.4519 18.465 23.2639 16.6064 23.4405 16.5663C23.565 16.538 23.7376 16.5025 23.8546 16.6064C23.9715 16.7104 23.96 16.9072 23.9476 16.96C23.8721 17.2819 20.8802 20.0635 19.3318 21.503C18.8491 21.9517 18.5068 22.2701 18.4368 22.3428C18.28 22.5056 18.1202 22.6597 17.9666 22.8077C17.0179 23.7222 16.3065 24.4081 18.006 25.528C18.8227 26.0662 19.4762 26.5113 20.1282 26.9553C20.8402 27.4402 21.5504 27.9238 22.4693 28.5261C22.7034 28.6796 22.927 28.839 23.1448 28.9942C23.9734 29.585 24.7179 30.1157 25.6376 30.0311C26.172 29.9819 26.7241 29.4794 27.0044 27.9806C27.667 24.4386 28.9693 16.7641 29.2703 13.6016C29.2967 13.3246 29.2635 12.97 29.2369 12.8143C29.2102 12.6586 29.1546 12.4369 28.9522 12.2727C28.7126 12.0782 28.3427 12.0372 28.1772 12.0402C27.425 12.0534 26.2709 12.4547 20.7167 14.7649Z" fill="white"/>
</svg>


            </div>
            <span>Telegram</span>
          </div>
          <div className="social-icon" onClick={() => shareToSocial("linkedin")}>
            <div className="icon-circle linkedin">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M36 2.64706V33.3529C36 34.055 35.7211 34.7283 35.2247 35.2247C34.7283 35.7211 34.055 36 33.3529 36H2.64706C1.94502 36 1.27173 35.7211 0.775306 35.2247C0.278886 34.7283 0 34.055 0 33.3529L0 2.64706C0 1.94502 0.278886 1.27173 0.775306 0.775306C1.27173 0.278886 1.94502 0 2.64706 0L33.3529 0C34.055 0 34.7283 0.278886 35.2247 0.775306C35.7211 1.27173 36 1.94502 36 2.64706V2.64706ZM10.5882 13.7647H5.29412V30.7059H10.5882V13.7647ZM11.0647 7.94118C11.0675 7.54072 10.9914 7.14363 10.8407 6.77259C10.69 6.40155 10.4677 6.06383 10.1866 5.77869C9.90535 5.49356 9.57074 5.26661 9.20183 5.1108C8.83292 4.95498 8.43693 4.87336 8.03647 4.87059H7.94118C7.12681 4.87059 6.34579 5.1941 5.76994 5.76994C5.1941 6.34579 4.87059 7.12681 4.87059 7.94118C4.87059 8.75555 5.1941 9.53656 5.76994 10.1124C6.34579 10.6883 7.12681 11.0118 7.94118 11.0118V11.0118C8.34166 11.0216 8.74016 10.9525 9.11391 10.8083C9.48766 10.664 9.82933 10.4476 10.1194 10.1713C10.4095 9.89499 10.6423 9.56424 10.8045 9.19793C10.9667 8.83163 11.0551 8.43696 11.0647 8.03647V7.94118ZM30.7059 20.4141C30.7059 15.3212 27.4659 13.3412 24.2471 13.3412C23.1932 13.2884 22.1438 13.5129 21.2037 13.9922C20.2637 14.4715 19.4657 15.189 18.8894 16.0729H18.7412V13.7647H13.7647V30.7059H19.0588V21.6953C18.9823 20.7725 19.273 19.8567 19.8677 19.1469C20.4625 18.4372 21.3133 17.9908 22.2353 17.9047H22.4365C24.12 17.9047 25.3694 18.9635 25.3694 21.6318V30.7059H30.6635L30.7059 20.4141Z" fill="white"/>
</svg>

            </div>
            <span>Linkedin</span>
          </div>
        </div>
      </div>
    </div>
  )
}

